module.exports = __webpack_public_path__ + "img/Jump Casting100.6855757d.jpg";